/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useState } from 'react';
import { Dropdown } from '@qubiteq/qublib';
import { PayPalButtons, usePayPalScriptReducer, PayPalMarks } from '@paypal/react-paypal-js';

const Checkout = () => {
    const [{ options, isPending }, dispatch] = usePayPalScriptReducer();
    const [currency, setCurrency] = useState(options.currency);
    const fundingSources = ['paypal', 'card', 'paylater'];
    const [selectedFundingSource, setSelectedFundingSource] = useState(fundingSources[0]);

    const onCurrencyChange = ({ target: { value } }) => {
        setCurrency(value);
        dispatch({
            type: 'resetOptions',
            value: {
                ...options,
                currency: value
            }
        });
    };

    const onCreateOrder = (data, actions) => {
        return actions.order.create({
            purchase_units: [
                {
                    amount: {
                        value: '20.70'
                    }
                }
            ]
        });
    };

    const onApproveOrder = (data, actions) => {
        return actions.order.capture().then((details) => {
            console.log(details);
            const name = details.payer.name.given_name;
            alert(`Transaction completed by ${name}`);
        });
    };

    const onChange = ({ target: { value } }) => {
        setSelectedFundingSource(value);
    };
    return (
        <div className="checkout">
            {isPending ? (
                <p>LOADING...</p>
            ) : (
                <>
                    <select value={currency} onChange={onCurrencyChange}>
                        <option value="USD">💵 USD</option>
                        <option value="EUR">💶 Euro</option>
                    </select>
                    <PayPalButtons
                        style={{ layout: 'vertical' }}
                        createOrder={(data, actions) => onCreateOrder(data, actions)}
                        onApprove={(data, actions) => onApproveOrder(data, actions)}
                    />
                </>
            )}
        </div>
    );
};

export default Checkout;
